/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Create_While_ListeningInputs */

const en_notes_create_while_listening = /** @type {(inputs: Notes_Create_While_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create notes while listening to audio files`)
};

const es_notes_create_while_listening = /** @type {(inputs: Notes_Create_While_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea notas mientras escuchas archivos de audio`)
};

/**
* | output |
* | --- |
* | "Create notes while listening to audio files" |
*
* @param {Notes_Create_While_ListeningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_create_while_listening = /** @type {((inputs?: Notes_Create_While_ListeningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Create_While_ListeningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_notes_create_while_listening(inputs)
	return en_notes_create_while_listening(inputs)
});